import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.sass']
})
export class TooltipComponent implements OnInit {
  @Input() message = '';
  @Input() position = 'bottom';
  @Input() params: any = {};

  constructor() { }

  ngOnInit() {
  }
}
